import { registerLocaleData } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { SiteAdminNoAuthGuard, SiteAdminAuthGuard } from './core/auth.guard';
import { AuthInterceptor } from './core/auth.interceptor';
import { ExtraOptions, PreloadAllModules, RouterModule, DefaultUrlSerializer, UrlTree, UrlSerializer, Route } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgxAwesomePopupModule, ConfirmBoxConfigModule } from '@costlydeveloper/ngx-awesome-popup';
import { ServiceWorkerModule } from '@angular/service-worker';

import { SharedModule } from './shared/shared.module';

import { SiteAdminLoginComponent } from './pages/site-admin-login/site-admin-login.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe, 'de');

const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules
};

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        // Optional Step: Do some stuff with the url if needed.

        // If you lower it in the optional step 
        // you don't need to use "toLowerCase" 
        // when you pass it down to the next function
        return super.parse(url.toLowerCase());
    }
}

export const routes: Route[] = [
    {
        path: "",
        canActivate: [SiteAdminAuthGuard],
        loadChildren: () => import('./site-admin/site-admin.module').then(m => m.SiteAdminModule)
    },
    {
        path: "",
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'login'
            }
        ]
    },
    {
        path: "login",
        canActivate: [SiteAdminNoAuthGuard],
        canActivateChild: [SiteAdminNoAuthGuard],
        component: SiteAdminLoginComponent
    },
    {
        path: '**',
        redirectTo: 'login'
    }
];


@NgModule({
    declarations: [
        AppComponent,
        SiteAdminLoginComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes, routerConfig),
        HttpClientModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-center',
            preventDuplicates: true,
            enableHtml: true,
            maxOpened: 1,
            autoDismiss: true,
            timeOut: 3000
        }),
        NgxAwesomePopupModule.forRoot(),
        ConfirmBoxConfigModule.forRoot({
            confirmBoxCoreConfig: {
                allowHtmlMessage: true
            }
        }),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: true }),
        SharedModule
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: UrlSerializer, useClass: LowerCaseUrlSerializer }

    ]
})
export class DoctorModule {
}
